import filter from 'lodash/filter';
import findIndex from 'lodash/findIndex';
import types from './mutationTypes';
import offerService from '../services/offer';
import TicketService from '../services/tickets';
import gateway from '../services/gateway';
import * as Ticket from '../model/ticket';
import gameConfig from '../config/gameConfig';

export default {
  gatewayLoaded: ({ commit }, payload) => {
    commit(types.GATEWAY_LOADED, payload);
  },
  setActiveGame: ({ commit }, payload) => {
    commit(types.CLOSE_TICKET_PREVIEW, false);
    commit(types.SET_ACTIVE_GAME, payload);
  },
  /**
   * Handle key event for game help
   * @param {Object} payload
   */
  masterEventMessage({ state, commit }, payload) {
    console.log('masterEventMessage', payload);
    if (!state.ticketPreviewShow) {
      switch (payload.key) {
        case '*': {
          if (gameConfig[state.gameId].print.active) {
            gateway.sendMessage('Widget.UpdateSettings', {
              gamesHelp: {
                show: false,
              },
              calculator: {
                show: false,
              },
              ticketSession: {
                show: false,
              },
              ticketList: {
                show: false,
              },
            });
            const path = gameConfig[state.gameId].print.routes.offer ? '/printOffer' : '/printResults';
            console.log(path);
            payload.router.push({ path });
          }
          break;
        }
        case 'o': {
          if (gameConfig[state.gameId].offer.active) {
            const show = payload.router.currentRoute.name === 'fullOffer';
            const routerPathMapper = {
              betting: 'offer',
              fullOffer: 'betting',
              betOffer: 'fulloffer',
            };
            gateway.sendMessage('Widget.UpdateSettings', {
              gamesHelp: {
                show,
              },
              calculator: {
                show,
              },
              ticketSession: {
                show,
              },
              ticketList: {
                show,
              },
            });
            commit(types.SET_SEARCHED_VALUE, '');
            payload.router.push({ path: `/${routerPathMapper[payload.router.currentRoute.name]}` });
          }
          break;
        }
        case '+': {
          // commit(types.CLEAR_BETS);
          commit(types.EDIT_BET, {});
          gateway.sendMessage('Widget.UpdateSettings', {
            gamesHelp: {
              show: true,
            },
            calculator: {
              show: true,
            },
            ticketSession: {
              show: true,
            },
            ticketList: {
              show: true,
            },
          });
          payload.router.push({ path: 'betting' });
          break;
        }
        case 'c':
        case 'm':
        case '/': {
          commit(types.SET_KEY_EVENT_TIMESTAMP, `${payload.key}_${new Date().getTime()}`);
          break;
        }
        // no default
      }
    }
  },
  ticketPreviewDoAction({ state, dispatch }, payload) {
    if (payload) {
      if (payload.key !== 1) {
        const data = {
          ticket: state.ticketPreview.ticket,
          action: {
            id: payload.id,
          },
        };
        gateway.sendMessage('Tickets.Action', data);
      }
    }
    dispatch('closeTicketPreview', false);
  },
  /**
   * Handle socket message
   * @param {Object} payload
   */
  socketMessage({ state, commit, dispatch }, payload) {
    const payloadData = state.gameId === 'SportradarVirtualFootball' ? payload.data : payload;
    const offer = () => {
      offerService.fetchOffer(window.sevenConfig.company.language, state.gameId)
        .then(
          (response) => {
            commit(types.SET_OFFER, response.data);
            if (state.bets.length) {
              dispatch('checkBetslip');
            }
            commit('SOCKET_CONNECT', true);
          },
          () => {
            const errorData = {
              action: 'Dialog.ShowModal',
              data: {
                action: '7S:Dialog.ShowModal',
                message: "Didn't fetch offer",
                type: 'warning',
                delay: 0,
              },
            };
            gateway.sendMessage(errorData);
          },
        );
    };
    switch (payload.type) {
      case 'keepAlive': {
        if (state.socketKeepAlive) {
          const seconds = parseInt(Math.abs(state.socketKeepAlive - payload.sentTime) / 1000, 10);
          if (seconds > 20) {
            offer();
          }
        }
        commit(types.SOCKET_KEEP_ALIVE, payload.sentTime);
        break;
      }
      case 'betting': {
        if (Object.prototype.hasOwnProperty.call(state.offer, payloadData.data.idMatch)) {
          commit(types.SOCKET_MESSAGE_BETTING, payloadData.data);
        }
        if (state.bets.length > 0) {
          let i = 0;
          let betslipBetChanged = false;
          const newBets = state.bets.slice();
          while (i < newBets.length) {
            if (newBets[i].idMatch === payloadData.data.idMatch) {
              betslipBetChanged = true;
              newBets[i].bettingStatus = payloadData.data.bettingStatus;
              if (state.activeBetType === 'combo') {
                commit(types.RE_BET, {
                  bets: newBets,
                  rebet: state.rebet,
                });
                return;
              }
            }
            i += 1;
          }
          if (betslipBetChanged) {
            commit(types.RE_BET, {
              bets: newBets,
              rebet: state.rebet,
            });
          }
        }
        break;
      }
      case 'change': {
        if (Object.prototype.hasOwnProperty.call(state.offer, payloadData.data.idMatch)) {
          commit(types.UPDATE_MATCH_IN_OFFER, payloadData.data);
        } else {
          commit(types.ADD_TO_OFFER, payloadData.data);
        }
        break;
      }
      case 'remove': {
        if (Object.keys(state.offer).length > 0) {
          let i = 0;
          let j = 0;
          let offerChanged = false;
          // let betsChanged = false;
          const newOffer = Object.assign({}, state.offer);
          const newBets = state.bets.slice();
          while (i < payloadData.data.length) {
            if (Object.prototype.hasOwnProperty.call(state.offer, payloadData.data[i])) {
              delete newOffer[payloadData.data[i]];
              offerChanged = true;
            }
            while (j < newBets.length) {
              if (newBets[j].idMatch === payloadData.data[i]) {
                newBets[j].bettingStatus = false;
                // betsChanged = true;
              }
              j += 1;
            }
            i += 1;
          }
          if (offerChanged) {
            commit(types.UPDATE_OFFER, newOffer);
          }

          // Update bets on betslip if betting status change
          // but for now we don't need this update on betslip
          /* if (betsChanged) {
            console.log(' betsChanged iff ', newBets);
            commit(types.RE_BET, {
              bets: newBets,
              rebet: state.rebet,
            });
          } */
        }
        break;
      }
      case 'ticketUpdate': {
        const actionCapitalize = payload.data.data.action.replace(payload.data.data.action[0],
          payload.data.data.action[0].toUpperCase());
        const data = {
          action: actionCapitalize,
          printAction: actionCapitalize === 'Add' ? '' : actionCapitalize,
          ticketData: payload.data.data,
        };
        gateway.sendMessage('Tickets.Update', data);
        break;
      }
      case 'globalBetting': {
        commit(types.SET_GLOBAL_BET_STOP, payload.data.globalBetstop);
        break;
      }
      // no default
    }
  },
  setActiveBetType: ({ commit }, payload) => {
    commit(types.SET_ACTIVE_BET_TYPE, payload);
  },
  setSingleStake: ({ commit }, payload) => {
    commit(types.SET_SINGLE_STAKE, payload);
  },
  setComboStake: ({ commit }, payload) => {
    commit(types.SET_COMBO_STAKE, payload);
  },
  setMatch: ({ commit }, payload) => {
    commit(types.SET_MATCH, payload);
  },
  setBet: ({ commit }, payload) => {
    commit(types.SET_BET, payload);
  },
  setOutcome: ({ commit }, payload) => {
    commit(types.SET_OUTCOME, payload);
  },
  /**
   * Add bet on betslip
   */
  addBet: ({ commit }, payload) => {
    commit(types.ADD_BET, payload);
  },
  reBet: ({ state, commit }, payload) => {
    let tempStatus = false;
    let tempBet = {};
    const tempBets = [];
    const tempOffer = Object.assign({}, state.offer);
    payload.bets.forEach((bet) => {
      if (Object.keys(state.offer).length > 0) {
        if (Object.prototype.hasOwnProperty.call(state.offer, bet.matchId)) {
          tempStatus = tempOffer[bet.matchId].bettingStatus;
        }
        tempBet = new Ticket.ReBet(bet, tempStatus);
        tempBets.push(tempBet);
      }
    });
    commit(types.RE_BET, {
      bets: tempBets,
      rebet: payload,
    });
    commit(types.EDIT_BET, {});
  },
  /**
   * Edit bet on betslip
   */
  editBet: ({ state, commit }, payload) => {
    if (Object.keys(state.editBet).length > 0
      && state.editBet.data.betUuid === state.bets[payload].betUuid) {
      commit(types.EDIT_BET, {});
      commit(types.CLEAR_SELECTED);
    } else {
      commit(types.EDIT_BET, {
        data: state.bets[payload], index: payload,
      });
    }
  },
  /**
   * Update bet/match on betslip
   */
  changeBet: ({ commit }, payload) => {
    commit(types.CHANGE_BET, payload);
  },

  /**
   * Remove bet/match from betslip
   */
  removeBet: ({ state, commit }, payload) => {
    if (Object.keys(state.editBet).length > 0
      && state.editBet.data.betUuid === state.bets[payload].betUuid) {
      commit(types.EDIT_BET, {});
    }
    commit(types.REMOVE_BET, payload);
  },
  /**
   * Remove all bets from betslip
   */
  clearBets: ({ commit }) => {
    commit(types.CLEAR_BETS);
    commit(types.EDIT_BET, {});
  },
  clearRebet: ({ commit }) => {
    commit(types.CLEAR_REBET);
  },
  /**
   * Reset selected data (match, bet, outcome)
   */
  clearSelected: ({ commit }) => {
    commit(types.CLEAR_SELECTED);
  },
  /**
   * Remove duplicate bets from betslip
   * If 'combo' bet type
   */
  removeExistBets: ({ state, commit }) => {
    let i = 0;
    let matches = [];
    const tempBets = [];

    function checkMatches(obj) {
      return state.bets[i].idMatch === obj.idMatch;
    }

    function hasMatch(obj) {
      return matches[0].idMatch === obj.idMatch;
    }

    if (state.bets.length > 1) {
      while (i < state.bets.length) {
        matches = [];
        matches = filter(state.bets, checkMatches);
        const index = findIndex(tempBets, hasMatch);
        if (index < 0) {
          tempBets.push(matches[0]);
        }
        i += 1;
      }
      if (tempBets.length > 0) {
        commit(types.RE_BET, {
          bets: tempBets,
          rebet: state.rebet,
        });
      }
    }
  },
  /**
   * Remove lock bets from betslip
   */
  removeLockBets: ({ state, commit }) => {
    const tempBets = filter(state.bets, obj => obj.bettingStatus);
    // if (tempBets.length > 0) {
    commit(types.RE_BET, {
      bets: tempBets,
      rebet: state.rebet,
    });
    // }
  },
  sendMessage: ({ commit }, payload) => {
    commit(types.SEND_MESSAGE, payload);
  },
  setPotentionalWin: ({ commit }, payload) => {
    commit(types.SET_POTENTIONAL_WIN, payload);
  },
  /**
   * Betslip payin action
   */
  callPayin: ({ state }, payload) => {
    // do not process ticket if betslip is empty
    if (!state.bets.length) {
      gateway.sendMessage('Dialog.ShowModal', {
        action: '7S:Dialog.ShowModal',
        message: state.translations.betsAreNotSelected || 'betsAreNotSelected',
        type: 'warning',
        delay: 3000,
      });
      return;
    }
    const ticketFormatted = TicketService.formatter(payload, state);
    const payinData = {
      validateTicket: false,
      skipBetslipReset: true,
      ticketFormatted,
    };
    gateway.sendMessage('Tickets.Pay', payinData);
  },
  /**
   * Update selected data
   */
  updateSelected: ({ commit }, payload) => {
    commit(types.UPDATE_SELECTED, payload);
  },
  setSearchedValue: ({ commit }, payload) => {
    commit(types.SET_SEARCHED_VALUE, payload);
  },
  setSearchInputActive: ({ commit }) => {
    commit(types.SET_SEARCHED_INPUT_ACTIVE, Date.now());
  },
  goHome({ commit }, payload) {
    commit(types.EDIT_BET, {});
    gateway.sendMessage('Widget.UpdateSettings', {
      gamesHelp: {
        show: true,
      },
      calculator: {
        show: true,
      },
      ticketSession: {
        show: true,
      },
      ticketList: {
        show: true,
      },
    });
    payload.push({ path: 'betting' });
  },
  setSocketConnect: ({ commit }, payload) => {
    commit(types.SOCKET_CONNECT, payload);
  },
  setTicketPreview: ({ commit }, payload) => {
    commit(types.SET_TICKET_PREVIEW, payload);
  },
  closeTicketPreview: ({ commit }, payload) => {
    if (payload === false) {
      gateway.sendMessage('Widget.UpdateSettings', {
        gamesHelp: {
          show: true,
        },
        calculator: {
          show: true,
        },
        ticketSession: {
          show: true,
        },
        ticketList: {
          show: true,
        },
      });
    }
    commit(types.CLOSE_TICKET_PREVIEW, payload);
  },
  /**
   * Check bets on betslip when we reconnect internet
   */
  checkBetslip: ({ state, commit }) => {
    const bets = state.bets.slice();
    let i = 0;
    while (i < bets.length) {
      if (!Object.prototype.hasOwnProperty.call(state.offer, bets[i].idMatch)) {
        bets[i].bettingStatus = false;
      }
      i += 1;
    }
    commit(types.RE_BET, {
      bets,
      rebet: null,
    });
  },
  setBetslipBlocked: ({ commit, state }, payload) => {
    console.log('setBetslipBlocked start', payload);
    let i = 0;
    const newBetslipBlockers = state.betslipBlocked;
    const checkArray = () => findIndex(newBetslipBlockers,
      blocker => blocker.id === payload.blockers[i].id);
    while (i < payload.blockers.length) {
      const index = checkArray();
      if (payload.type === 'add') {
        if (index < 0) {
          newBetslipBlockers.push(payload.blockers[i]);
        }
      } else if (index >= 0 && payload.type !== 'add') {
        newBetslipBlockers.splice(index, 1);
      }
      i += 1;
    }
    console.log('setBetslipBlocked END', newBetslipBlockers);
    commit(types.SET_BETSLIP_BLOCKED, newBetslipBlockers);
  },
};
